import type { IChipEditorModel, IChipModel } from '@/interfaces/models';
import { ChipEditorModel } from '@/models/ChipEditorModel';
import { CircuitEditorModelFactory } from '@/factories/CircuitEditorModelFactory';

export class ChipEditorModelFactory {
  constructor(private readonly circuitEditorModelFactory: CircuitEditorModelFactory) {}

  create(chipModel: IChipModel): IChipEditorModel {
    const logicCircuitEditor = this.circuitEditorModelFactory.create(
      chipModel.logicCircuit.circuitModel,
    );
    const structureCircuitEditor = this.circuitEditorModelFactory.create(
      chipModel.structureCircuit.circuitModel,
    );

    return new ChipEditorModel({
      chipModel,
      logicCircuitEditor,
      structureCircuitEditor,
    });
  }
}
